import { system } from 'styled-system';

export const gutter = system({
  gutter: {
    property: 'margin',
    scale: 'space',
    transform: (value, scale) => {
      let propertyValue = value;
      if (typeof value === 'string') propertyValue = scale[parseInt(value)];
      const gutterDimension = propertyValue / 2;

      return `0 -${gutterDimension}px 0 -${gutterDimension}px`;
    },
  },
});
